import { render } from "./PrivacyPolicy.vue?vue&type=template&id=7a5daa62&scoped=true"
const script = {}

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=7a5daa62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a5daa62"]])

export default __exports__